module.exports = __webpack_public_path__ + "img/add-circle.6b2330ba.svg";